/**
 * ESM facade for @x9/task-pipeline.
 *
 * The implementation lives once in ./index.cjs (CommonJS) so Node, Jest, Metro,
 * and the esbuild Functions bundle can `require` it. This thin wrapper exposes
 * the same surface as static ESM named exports so Vite/Rollup (web PWA) can
 * statically link them. No logic is duplicated.
 */
import mod from './index.cjs';

export const {
  STATUSES,
  EVENT_TYPES,
  REASSIGNMENT_RESET_STATUSES,
  VALID_TRANSITIONS,
  PRIMARY_ACTION,
  canTransition,
  nextPrimaryAction,
  historyEventTypeForStatus,
  reassignmentStatusReset,
  parseStatusHistory,
  hasReopenEvent,
  deriveDisplayStatus,
  ARCHIVE_POLICY,
  ARCHIVABLE_TASK_STATUSES,
  isTaskArchivable,
  taskSettledAtMs,
} = mod;

export default mod;
